<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
        <el-breadcrumb-item>地图列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 
                <el-col :span="5" >
                    <el-input placeholder="机器编号" v-model="dataMap.robotNo" class="m-l-30 ell-input"></el-input>
                </el-col>
                -->
                <el-col :span="5" >
                    <el-input placeholder="地图编号" v-model="dataMap.mapNo" class="m-l-30 ell-input"> </el-input>
                </el-col>
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchDataMaps()">查询</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                 <el-button type="primary" @click="returnMissionRobot()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="dataMapList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="250"></el-table-column>
            <el-table-column label="地图编号" prop="mapNo" width="250"></el-table-column>
            <el-table-column label="使用状态" prop="isUser" width="250">
                <template slot-scope="scope">
                   <span v-if="scope.row.isUser==0" >
                            否
                   </span>
                   <span v-if="scope.row.isUser==1" style="color:blue">
                            是
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="操作" prop="" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.isUser==1">
                        <el-tooltip effect="dark" content="查看任务点信息" placement="top" :enterable="false"  >  
                            <el-button type="warning" icon="el-icon-view" size="mini" @click="viewNode(scope.row)"></el-button>
                        </el-tooltip>
                    </span>
                    <el-tooltip effect="dark" content="设置任务点信息" placement="top" :enterable="false"  >  
                        <el-button type="primary" icon="el-icon-s-tools" size="mini" @click="editNode(scope.row)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="dataMap.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>


         <!-- 编辑任务点信息 -->
        <el-dialog title="编辑任务点信息"  :visible.sync="editDataMapVisible"  width="50%" @close="editDataMapClose" >
             <template slot="title"> 
                <div style="font-size:25px;color:blue;">编辑任务点信息</div>    
            </template>
                <el-row  >
                    <el-col :span="10" >
                        <span style="font-size:20px;color:#000000;">机器编号:</span><span  style="font-size:20px;color:#67C23A;"> {{editDataMap.robotNo}} </span>
                    </el-col>
                    <el-col :span="10" >
                         <span style="font-size:20px;color:#000000;">地图编号:</span>  <span style="font-size:20px;color:#67C23A;"> {{editDataMap.mapNo}}</span>
                    </el-col>
                </el-row>
                <el-row   >
                    <!-- 用户列表区域 -->
                    <el-table :data="pointinfoList" border   stripe  height="300" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" @cell-click="tabClick"  :row-class-name="tableRowClassName" >
                        <el-table-column label="点位编号" prop="pointNo" width="100"></el-table-column>
                        <el-table-column label="楼栋编号"  width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '楼栋编号'">
                                    <el-input v-model="scope.row.buildingNo" maxlength="150" placeholder="楼栋编号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.buildingNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="楼层编号" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '楼层编号'">
                                    <el-input v-model="scope.row.floorNo" maxlength="150" placeholder="楼层编号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.floorNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="房间号" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '房间号'">
                                    <el-input v-model="scope.row.roomNo" maxlength="150" placeholder="房间号" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                                </span>
                                <span v-else>{{ scope.row.roomNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="房间备注信息"  width="360">
                            <template slot-scope="scope">
                                <span v-if="scope.row.index === tabClickIndex && tabClickLabel === '房间备注信息'">
                                    <el-input v-model="scope.row.roomInfo" maxlength="150" placeholder="房间备注信息" size="mini" @blur="inputBlur" class="ell-input"/>
                                </span>
                                <span v-else>{{ scope.row.roomInfo }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row   :gutter='20' >
                    <el-col :span="14">
                    　<canvas id="mycanvas1" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                    </el-col>
                </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDataMapVisible = false">取 消</el-button>
                <el-button type="primary" @click="editDataMapData()">确 定</el-button>
            </span>
        </el-dialog>
        <!--下发任务-->
        <el-dialog title="任务点信息"  :visible.sync="viewDataMapVisible"  width="50%" @close="viewDataMapClose" >
            <template slot="title"> 
                <div style="font-size:25px;color:blue;">任务点信息</div>    
            </template>
                <el-row  >
                    <el-col :span="10" >
                        <span style="font-size:20px;color:#000000;">机器编号:</span><span  style="font-size:20px;color:#67C23A;"> {{viewDataMap.robotNo}} </span>
                    </el-col>
                    <el-col :span="10" >
                         <span style="font-size:20px;color:#000000;">地图编号:</span>  <span style="font-size:20px;color:#67C23A;"> {{viewDataMap.mapNo}}</span>
                    </el-col>
                </el-row>
                <el-row   >
                    <!-- 用户列表区域 -->
                    <el-table :data="viewPointinfoList"  border   stripe  height="300" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" @cell-click="tabClick"  :row-class-name="tableRowClassName" >
                        <el-table-column label="点位编号" prop="pointNo" width="80"></el-table-column>
                        <el-table-column label="楼栋编号" prop="buildingNo" width="80"></el-table-column>
                        <el-table-column label="楼层编号" prop="floorNo" width="80"></el-table-column> 
                        <el-table-column label="房间号"   prop="roomNo" width="80"></el-table-column>
                        <el-table-column label="房间信息" prop="roomInfo" width="250"></el-table-column>
                        <el-table-column label="消杀时长(s)"  width="140">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.time"  maxlength="150" placeholder="消杀时长(s)" size="mini" @blur="inputBlur" class="elll-input" oninput="value=value.replace(/[^\d]/g,'');if(value.length>4)value=value.slice(0,4)"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" prop="" width="120">
                            <template slot-scope="scope">
                                <!-- 删除按钮 -->
                                <span >
                                    <el-button type="primary"  size="mini"  @click="issuetask(scope.row)">下发任务</el-button>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row   :gutter='20' >
                    <el-col :span="14">
                    　<canvas id="mycanvas2" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                    </el-col>
                    <el-col :span="10">
                        <el-row>
                            
                        </el-row>
                        
                    　  <el-row>
                             <!-- 点位编号 -->
                            <el-col :span="8" >
                                <span style="font-size:23px;color:blue;">点位编号:</span>
                            </el-col>
                             <el-col :span="4" >
                               <el-input placeholder="暂无数据" v-model="pointInfo.pointNo"  ></el-input>
                            </el-col>
                        </el-row>
                        <el-row>
                              <!-- 点位编号 -->
                            <el-col :span="8" >
                                <span style="font-size:23px;color:blue;">工作状态:</span>
                            </el-col>
                             <el-col :span="4" >
                               <el-input placeholder="暂无数据" v-model="pointInfo.state"  ></el-input>
                            </el-col>
                         </el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row></el-row>
                        <el-row >
                            <el-col :push="13" >
                                <el-button type="primary"  size="medium "  @click="endTask()">结束当前任务</el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
        </el-dialog>
        <!--下发任务进度条 -->
        <el-dialog title="下发任务中"  :visible.sync="dialogProgressTaskVisible" class="taskdialog" :showClose="false" @close="progressTaskDialogClose">
            <el-progress type="circle" :percentage="taskPercentage" :status="progressStatus"></el-progress>
        </el-dialog>
        <!--结束任务进度条 -->
        <el-dialog title="下发结束任务中"  :visible.sync="endTaskInfo.endTaskVisible" class="taskdialog" :showClose="false" @close="endDialogClose">
            <el-progress type="circle" :percentage="endTaskInfo.endPercentage" :status="endTaskInfo.endProgressStatus"></el-progress>
        </el-dialog>

    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'machine',
  data(){
      return {
          dataMap :{
              robotNo:'',
              mapNo:'',
              num:1,
          },
          editDataMapRules:{},
          dataMapList:[],
          total:0,
          editDataMapVisible:false,
          editDataMap:{},
          resolution:'',
          origin_x:'',
          origin_y:'',
          pointinfoList:[],
          tabClickIndex: null, // 点击的单元格
          tabClickLabel: '', // 当前点击的列名
          formData:new FormData(),
          robotNo:'',
          viewDataMap:{},
          viewPointinfoList:[
            {
              pointNo:'',  
              buildingNo:'',
              floorNo:'',
              roomNo:'',
              roomInfo:'',
              time:'',
            }    
          ],
          viewDataMapVisible:false,
          dialogProgressTaskVisible:false,
          progressStatus:null,
          taskTimer:null,
          taskPercentage:10,
          topic1:'',
          topic2:'',
          topic3:'',
          globleX:'',
          globleY :'',
          pointInfo:{
                pointNo:'',
                state:''
          },
          mycanvas2Flag:false , //标记没有查到数据
          gcanvas:null,
          endTaskInfo:{
              endTaskVisible:false,
              endPercentage:10,
              endProgressStatus:null
          },
          endTaskTimer:null

      }
  },
   computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
    this.connectMqtt();
    //  setInterval(()=>{
    //       this.localReload()}
    //       ,6000000);
  },
   beforeRouteLeave(to, form, next) {
        if(this.mqttClient!=='' && this.mqttClient!==null){
            this.unsubscribe()
        } 
        next()
  },
  methods:{
        //结束当前任务
        endTask(){
            let that=this
            this.endTaskInfo.endTaskVisible=true;
            this.$http.get('map/endTask',{params :{ robotNo : this.viewDataMap.robotNo,mapNo :  this.viewDataMap.mapNo }})
            .then(response => {
                    if (response.data.code === 200) {
                        let timeOut=0
                        that.endTaskTimer = setInterval(() => {
                            if(timeOut > 15){
                                that.endTaskInfo.endProgressStatus="exception"
                                var t 
                                clearTimeout(t)
                                t = setTimeout(function() {
                                    that.endTaskInfo.endTaskVisible=false;
                                }, 2000)
                                that.$message.error("任务回复超时!");
                                clearInterval(that.endTaskTimer);
                               // that.clearParams();
                            }
                            if(that.endTaskInfo.endPercentage < 90){
                                that.endTaskInfo.endPercentage=that.endTaskInfo.endPercentage+10
                            }      
                        timeOut=timeOut+1      
                    }, 1000);
                    return
                }else{
                    setTimeout(function() {
                     that.endTaskInfo.endTaskVisible=false;
                    }, 2000)
                    return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
                
            })
        },
        endDialogClose(){
            this.endTaskInfo.endPercentage=10;
            this.endTaskInfo.endProgressStatus=null;
            clearInterval(this.endTaskTimer);
        },
        progressTaskDialogClose(){
            this.progressStatus=null;
            this.dialogProgressTaskVisible=false;
            clearInterval(this.taskTimer);
            this.taskPercentage=10;
        },
        connectMqtt(){
             if(this.mqttClient==null){
                //启动vuex初始化方法
                this.$store.dispatch('mqttServer')
                let that=this
                setTimeout(function() {
                       that.init();
                       that.searchDataMaps();
                    }, 1000)
             }else{
                this.init();
                this.searchDataMaps();
            }  
        },
        init(){
            var robotNo=this.$route.query.robotNo;
            if(robotNo==undefined||robotNo==''){
                this.$message.error("页面信息错误,请重新登录!");
                return
            }
            var topic1="/Unione/CommandReply/"+robotNo
            this.topic1=topic1
            var topic2="/Unione/TaskRecordForHMS"
            this.topic2=topic2
            var topic3="/Unione/DisinfectInfo/"+robotNo
            this.topic3=topic3
            try {
                this.mqttClient.subscribe(topic1, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic1)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
                this.mqttClient.subscribe(topic2, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic2)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
                this.mqttClient.subscribe(topic3, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic3)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
            } catch (e) {
                var subscribe=window.sessionStorage.getItem('subscribe')
                if(subscribe*1===1){
                    return this.$message.error("网络差,退出重新登录!");
                }else{
                    window.sessionStorage.setItem("subscribe",1)
                    this.$store.dispatch('mqttServer')
                    location.reload()
                    return 
                }
                
            }
            let that=this
            // 接收消息处理
            this.mqttClient.on('message', (topic, message) => {
                var data =JSON.parse(message)
                //消息回复
                if(topic == that.topic1){
                    //调度任务
                    if(that.dialogProgressTaskVisible &&  data.type=='4'){
                    if(data.code != "0" ){
                            that.$message.error(data.detail);
                    }else{
                            that.taskPercentage=100
                    }
                    var t
                    clearTimeout(t)
                        t=setTimeout(function() {
                                that.dialogProgressTaskVisible=false
                            }, 1000)
                    }
                }
                 if(topic == that.topic1){
                    //结束当前任务
                    if(that.endTaskInfo.endTaskVisible &&  data.type=='5'){
                    if(data.code != "0" ){
                            that.$message.error(data.detail);
                    }else{
                            that.endTaskInfo.endPercentage=100
                    }
                    var t
                    clearTimeout(t)
                        t=setTimeout(function() {
                                that.endTaskInfo.endTaskVisible=false
                            }, 1000)
                    }
                }
                //触发任务
                if(topic.startsWith("/Unione/TaskRecordForHMS")){
                    if(data.robot_no != that.viewDataMap.robotNo){
                        return
                    }else{
                        if(data.work_state==0){
                            that.pointInfo.state="任务启动"
                        }
                        if(data.work_state==1){
                            that.pointInfo.state="到消毒点"
                        }
                        if(data.work_state==2){
                            that.pointInfo.state="完成消杀"
                        }
                        if(data.work_state==3){
                            that.pointInfo.state="回到原点"
                        }
                        that.pointInfo.pointNo=data.goal_id
                    }
                    console.log(data)
                }
                if(topic == that.topic3){
                    if(this.mycanvas2Flag){
                        that.globleX= (parseFloat(data.pos_x) - that.origin_x) / that.resolution
                        that.globleY= that.imageHeight - (parseFloat(data.pos_y) - that.origin_y) / that.resolution
                        that.updateCanvas()
                    }
                }
            })
        },
        unsubscribe: function() {  
            this.mqttClient.unsubscribe(  
                    this.topic1, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
            this.mqttClient.unsubscribe(  
                    this.topic2, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
        },  
        updateCanvas(){
            var that = this
            var context = that.gcanvas.getContext('2d')
            var scale = window.devicePixelRatio
            context.scale(scale, scale)
            var img = new Image()
            img.src = this.viewDataMap.mapPngUrl
             // 加载图片
            img.onload = function() {
                  if (img.complete) {
                        // 根据图像重新设定了canvas的长宽
                        that.gcanvas.setAttribute('width', img.width)
                        that.gcanvas.setAttribute('height', img.height)
                        that.imageWidth = img.width
                        that.imageHeight = img.height
                         // 绘制图片
                        context.drawImage(img, 0, 0, img.width, img.height)
                        var x1 = (0 - that.origin_x) / that.resolution
                        var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                        that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                        that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                        for (var j = 0; j < that.viewDataMap.lineList.length; j++) {
                            var m = parseInt(that.viewDataMap.lineList[j].src_id)
                            var n = parseInt(that.viewDataMap.lineList[j].dst_id)
                            var x = parseFloat(that.viewDataMap.dotList[m].X)
                            var y = parseFloat(that.viewDataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(that.viewDataMap.dotList[n].X)
                            var y2 = parseFloat(that.viewDataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < that.viewDataMap.dotList.length; l++) {
                            var x3 = parseFloat(that.viewDataMap.dotList[l].X)
                            var y3 = parseFloat(that.viewDataMap.dotList[l].Y)
                            x3 = (x3 - that.origin_x) / that.resolution
                            y3 = that.imageHeight - (y3 - that.origin_y) / that.resolution
                            that.doDrawSicle(context, x3, y3, 'green', 3,l)
                        }
                        that.doDrawSiclePath(context, that.globleX, that.globleY, 'yellow', 3)
                    }
                }
            

        },
        returnMissionRobot(){
              this.$router.replace({path: '/robot'})
        },
        issuetask(obj){
            if(obj.time==undefined){
                 return  this.$message.error("请输入消杀时长!");
            }
            if(obj.time*1 < 30  || obj.time*1 > 300 ){
                return  this.$message.error("请输入30~300数字!");
            }
            if(obj.pointNo==undefined || obj.buildingNo==undefined || obj.floorNo==undefined || obj.roomNo==undefined || obj.roomInfo==undefined  || obj.roomInfo==''){
                return  this.$message.error("请补全该点信息!");
            }
            let that=this
            this.dialogProgressTaskVisible=true;
            this.$http.get('map/issueTask',{params :{ robotNo : obj.robotNo,mapNo : obj.mapNo ,pointNo : obj.pointNo,time: obj.time}})
            .then(response => {
                    if (response.data.code === 200) {
                        let timeOut=0
                        that.taskTimer = setInterval(() => {
                            if(timeOut > 15){
                                that.progressStatus="exception"
                                setTimeout(function() {
                                    that.dialogProgressTaskVisible=false;
                                    that.taskPercentage=10;
                                    that.progressStatus=null
                                }, 1000)
                                that.$message.error("任务回复超时!");
                                clearInterval(that.taskTimer);
                               // that.clearParams();
                            }
                            if(that.taskPercentage < 90){
                                that.taskPercentage=that.taskPercentage+10
                            }      
                        timeOut=timeOut+1      
                    }, 1000);
                    return
                }else{
                    setTimeout(function() {
                     that.dialogProgressTaskVisible=false
                     that.taskPercentage=10
                    }, 2000)
                    return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
                
            })
        },
        viewNode(obj){
             this.$http.get('map/findPointInfos',{params :{ robotNo : obj.robotNo,mapNo : obj.mapNo }})
            .then(response => {
                    if (response.data.code === 200) {
                        if(response.data.result===undefined||response.data.result.length==0){
                            return  this.$message.error("请设置任务点信息!");
                        }
                        this.viewPointinfoList=response.data.result
                        this.viewDataMapVisible=true
                        this.viewDataMap=obj
                        this.downloadOFile(this.viewDataMap.orginUrl,this.viewDataMap,"mycanvas2");
                        this.mycanvas2Flag=true;
                    }
                }).catch(failResponse => {
            })
        },
        //关闭观察框
        viewDataMapClose(){
            this.viewDataMap={}
            this.viewPointinfoList=[]
            this.viewDataMap={}
            this.mycanvas2Flag=false;
            this.pointInfo.state='';
            this.pointInfo.pointNo='';
            this.globleX='';
            this.globleY='';
            this.gcanvas=null;
        },
        tableRowClassName({ row, rowIndex }) {
            // 把每一行的索引放进row
            row.index = rowIndex
        },
        tabClick(row, column, cell, event) {
            this.tabClickIndex = row.index
            this.tabClickLabel = column.label
            console.log(this.tabClickIndex)
        },
        // 失去焦点初始化
        inputBlur(row, event, column) {
            this.tabClickIndex = null
            this.tabClickLabel = ''
       },
       searchDataMaps(){
            var check = /[`~!@#$%^&*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.dataMap.robotNo)||check.test(this.dataMap.mapNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.robotNo=this.$route.query.robotNo;
            this.$http.get('map/selectRobots',{params :{ robotNo : this.robotNo,mapNo : this.dataMap.mapNo,pageNum :this.dataMap.num }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.dataMapList=response.data.result.data
                        this.total=response.data.result.total
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })

       },
       editNode(obj){
            this.editDataMap=obj
            this.editDataMapVisible=true
            let  that=this
            this.$http.get('map/findPointInfos',{params :{ robotNo : obj.robotNo,mapNo : obj.mapNo }})
            .then(response => {
                    if (response.data.code === 200) {
                        if(response.data.result.length>0){
                            this.pointinfoList=response.data.result
                        }
                        this.downloadOFile(this.editDataMap.orginUrl,this.editDataMap,"mycanvas1");
                    }
                }).catch(failResponse => {
                
            })
            
       },

       clearParams(){
           this.dataMap.robotNO='';
           this.dataMap.mapNo='';
       },
       handleCurrentChange(page){
            this.dataMap.num=page;
            this.searchDataMaps();
       },
       editDataMapData(){
            let params = {mapNo:this.editDataMap.mapNo,robotNo:this.editDataMap.robotNo, pointinfos : this.pointinfoList}
            this.$http.post('/map/addPointInfo',JSON.stringify(params)) .then(response => {
                if (response.data.code === 200) {
                    this.editDataMapVisible=false;
                   return this.$message.success(response.data.message) 
                }else{
                    return this.$message.error(response.data.message) 
                }
                }).catch(failResponse => {

            })
       },
       editDataMapClose(){
           this.editDataMap=[];
           this.pointinfoList=[];
           this.tabClickIndex=null
           this.tabClickLabel=''
       },
       // 下载原点文件
       downloadOFile(url,dataMap,mycanva) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(dataMap.mapPngUrl)
                that.doDraw(dataMap.mapPngUrl,dataMap,mycanva)
            }  
            }).catch(res => {
                
            })
        },
         // imageUrl为后台提供图片地址
        doDraw(imageUrl,dataMap,mycanva) {
            // 获取canvas
            var canvas = document.getElementById(mycanva)
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById(mycanva)
                if (!canvas) {
                    return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(dataMap.roadUrl,dataMap)
                    }
                  }
                }
            }, 10)
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
        context.beginPath()
        context.moveTo(x1, y1)
        context.lineTo(x2, y2)
        context.strokeStyle = color
        context.lineWidth = line
        context.stroke()
        },
        //根据轨迹文件画图
        downloadRoadFile(url,dataMap) {
            console.log('加载xml文件')
            this.$http.get(window.location.origin+url)
                .then(res => {
                        const blob = new Blob([res.data])
                        const reader = new FileReader()
                        const that = this
                        reader.readAsText(blob, 'utf-8')
                        reader.onload = function() {
                        var xmlList = reader.result.split('<vertex')
                        var lineXmlList = reader.result.split('<edge')
                        var tempList = []
                        var lineist = []
                        for (var i = 1; i < xmlList.length; i++) {
                            var tempString = xmlList[i]
                            var Id = tempString.substring(tempString.indexOf('id="') + 4, tempString.indexOf('" visible='))
                            var X = tempString.substring(tempString.indexOf('x="') + 3, tempString.indexOf('" y="'))
                            var Y = tempString.substring(tempString.indexOf('y="') + 3, tempString.indexOf('" />'))
                            tempList.push({ Id, X, Y })
                            var pointin={ "pointNo" : Id*1}
                            //添加参考点
                            if( that.pointinfoList.length==0){
                                that.pointinfoList.push(pointin)
                            }else{
                                if(tempList.length>that.pointinfoList.length){
                                    that.pointinfoList.push(pointin)
                                }
                                
                            }
                            //观察点
                            if(that.viewPointinfoList.length>0  && tempList.length>that.viewPointinfoList.length ){
                               that.viewPointinfoList.push(pointin)
                            }
                        }
                        for (var k = 1; k < lineXmlList.length; k++) {
                            var lineString = lineXmlList[k]
                            var lid = lineString.substring(lineString.indexOf('id="') + 4, lineString.indexOf('" src_id='))
                            var src_id = lineString.substring(lineString.indexOf('src_id="') + 8, lineString.indexOf('" dst_id='))
                            var dst_id = lineString.substring(lineString.indexOf('dst_id="') + 8, lineString.indexOf('" directional='))
                            lineist.push({ lid, src_id, dst_id })
                        }
                        dataMap.dotList = tempList
                        dataMap.lineList = lineist
                        for (var j = 0; j < lineist.length; j++) {
                            var context = that.gcanvas.getContext('2d')
                            var scale = window.devicePixelRatio
                            context.scale(scale, scale)
                            var m = parseInt(lineist[j].src_id)
                            var n = parseInt(lineist[j].dst_id)
                            var x = parseFloat(dataMap.dotList[m].X)
                            var y = parseFloat(dataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(dataMap.dotList[n].X)
                            var y2 = parseFloat(dataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < tempList.length; l++) {
                            var context1 = that.gcanvas.getContext('2d')
                            var scale1 = window.devicePixelRatio
                            context1.scale(scale1, scale1)
                            var x1 = parseFloat(dataMap.dotList[l].X)
                            var y1 = parseFloat(dataMap.dotList[l].Y)
                            x1 = (x1 - that.origin_x) / that.resolution
                            y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                            that.doDrawSicle(context1, x1, y1, 'green', 3,l)
                        }
                    
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
        //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },

  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.elll-input {
    width: 100px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 

</style>


// WEBPACK FOOTER //
// src/components/robot/DataMap.vue